import { schoolStatsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

type SchoolDetailTypeProps = {
  schoolId: string;
  schoolType: string;
};

export default function SchoolDetailType({
  schoolId,
  schoolType,
}: SchoolDetailTypeProps) {
  return (
    <span
      className="text-xs sm:text-sm font-medium text-ink-emphasis"
      data-testid={`${schoolStatsTestIds.SCHOOL_TYPE}-${schoolId}`}
    >
      {schoolType}
    </span>
  );
}
